import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiThemeModule } from '@fitscovery/partner-web/ui/theme';
import { UiLoadMoreButtonComponent } from './ui-load-more-button/ui-load-more-button.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, UiThemeModule, TranslateModule],
  declarations: [UiLoadMoreButtonComponent],
  exports: [UiLoadMoreButtonComponent]
})
export class UiLoadMoreButtonModule {}
